import constants from '../../constants';

const { NAMESPACE: GLOBAL_NAMESPACE } = constants;

const NAMESPACE = `${GLOBAL_NAMESPACE}/file` as const;

const FETCH_FILES_URL_PARAMS = {
  GROUP_ID: 'group_id',
} as const;

const DELETE_FILE_MODAL_IDENTIFIER = `${NAMESPACE}/deleteFileModal` as const;

const FILE_DESCRIPTION_CHAR_BYTE_MAX_SIZE = 3;
const FILE_DESCRIPTION_MAX_LENGTH = 255;

export default {
  DELETE_FILE_MODAL_IDENTIFIER,
  FETCH_FILES_URL_PARAMS,
  FILE_DESCRIPTION_CHAR_BYTE_MAX_SIZE,
  FILE_DESCRIPTION_MAX_LENGTH,
  NAMESPACE,
};
